/**
 * constant({a: 'a', b: 'b'}).values()
 * // ['a', 'b']
 */ export default ((obj)=>{
    return {
        ...obj,
        values () {
            return Object.keys(obj).map((k)=>obj[k]);
        }
    };
});
